export enum DataType {
  delivery = 'delivery',
  visit = 'visit',
}
